import { TemplatePage } from './types';

const entertainmentPage: TemplatePage = {
  header: {
    color: '#FEE2EE',
    icon: 'images/video-templates/media-entertainment.jpg',
    title: 'Entertainment Video Templates',
    title_meta: '100+ Free Entertainment Video Templates',
    description_meta:
      'Amuse your audience big time with free entertainment video templates. Customize them for your brand in ' +
      'a few clicks. Try free!',
    description:
      'Create beautiful videos to engage your followers on social, promote special offers, illustrate your blog ' +
      'posts or website with 200+ entertainment video templates. Use Wave.video online editor to customize the ' +
      'videos to match your brand. Type your message, add a logo, and you are ready to go!'
  },
  footer: {
    category: 'Entertainment',
    description:
      'Wave.video’s collection of entertainment video templates allows you to make outstanding videos for ' +
      'promotions, social media, advertisement and events. Each template is fully customizable, so pick the one ' +
      'you like and dive into video creation!'
  },
  content: [
    {
      type: 'templates',
      title: 'Entertainment Video Templates',
      search: { category: '/Use Cases/Entertainment' }
    },
    {
      type: 'stocks',
      title: 'entertainment',
      search: { name: 'entertainment' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default entertainmentPage;
